import * as tslib_1 from "tslib";
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import { getMailboxJunkEmailConfiguration, saveMailboxJunkEmailConfiguration, } from 'owa-junkmail-configuration';
export default select({
    mailboxJunkEmailConfiguration: function () { return getMailboxJunkEmailConfiguration(); },
    optionState: function () { return store; },
})(action('saveSafeSendersOption')(function saveSafeSendersOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, mailboxJunkEmailConfiguration, optionState;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = state, mailboxJunkEmailConfiguration = _a.mailboxJunkEmailConfiguration, optionState = _a.optionState;
                    mailboxJunkEmailConfiguration.TrustedSendersAndDomains = optionState.safeSenders;
                    return [4 /*yield*/, saveMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveSafeSendersOption.js.map